var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EC4899",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 36.1252C19.25 37.7002 18.625 42.3752 18.625 42.3752C18.625 42.3752 23.3 41.7502 24.875 39.8752C25.7625 38.8252 25.75 37.2127 24.7625 36.2377C24.2766 35.7739 23.6366 35.506 22.9653 35.4852C22.2939 35.4644 21.6386 35.6923 21.125 36.1252Z",
    stroke: "#EC4899",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 34.2498L26.75 30.4998C27.4152 28.7741 28.2528 27.1199 29.25 25.5623C30.7065 23.2336 32.7345 21.3161 35.1413 19.9924C37.548 18.6687 40.2533 17.9828 43 17.9998C43 21.3998 42.025 27.3748 35.5 31.7498C33.9211 32.7482 32.2461 33.5857 30.5 34.2498Z",
    stroke: "#EC4899",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 30.4999H20.5C20.5 30.4999 21.1875 26.7124 23 25.4999C25.025 24.1499 29.25 25.4999 29.25 25.4999",
    stroke: "#EC4899",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 34.25V40.5C30.5 40.5 34.2875 39.8125 35.5 38C36.85 35.975 35.5 31.75 35.5 31.75",
    stroke: "#EC4899",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.3a78b73d48a71a3ee726dba975630ee3.svg";
export { ForwardRef as ReactComponent };